import { LOAD, LOAD_SUCCESS, LOAD_FAIL } from 'redux/actions/sourceAction';
import { flattenChildren } from 'utils/util-element';

const initialState = {
  loaded: false,
  loading: false,
  data: [],
};

function sourceReducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true,
        loaded: false
      };
    case LOAD_SUCCESS:
      const sourceList = state.data ? { ...state.data, ...action.payload.data } : action.payload.data;
      return {
        ...state,
        loading: false,
        loaded: true,
        data: flattenChildren(sourceList),
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    default:
      return state;
  }
}

export default sourceReducer;
